import apiService from "../../api/api.service";
import {
  InitiatePaymentRequest,
  InitiatePaymentResponse,
} from "./payment.types";

export const initiatePayment = (data: InitiatePaymentRequest) => {
  return apiService.post<InitiatePaymentResponse, InitiatePaymentRequest>(
    "/payment/initiate",
    data,
  );
};
